import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {GlobalCacheService} from '../../service/global-cache.service';
import {NavigateService} from 'src/app/shared/service/navigate.service';
import {Router, ActivatedRoute, ParamMap} from '@angular/router';
import {UtilService} from '../../../shared/utils/util.service';
import {TemplateService} from 'src/app/routes/home/template.service';
import {CommonServiceService} from '../../service/common-service.service';


@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  constructor(
    public globalCacheService: GlobalCacheService,
    public navigateService: NavigateService,
    public activatedRoute: ActivatedRoute,
    public utilService: UtilService,
    public templateService: TemplateService,
    public commonService: CommonServiceService,
  ) {
  }

  @Input() title: any = {};

  public navigation: { title: string, templateId: string };
  public paramsSubscription;

  public template: {};
  public templateName;
  public templateId;
  public pid;
  public elderId;
  public lucaId01;
  public lucaId02;
  public lucaId03;

  public elderTitle;
  public lucaTitle01;
  public lucaTitle02;
  public lucaTitle03;

  ngOnInit(): void {
    // tslint:disable-next-line:no-shadowed-variable
    this.paramsSubscription = this.activatedRoute.queryParamMap.subscribe(params => {
      this.templateName = params.get('templateName');
      this.templateId = params.get('templateId');
      this.pid = params.get('pid');
      this.template = {
        title: this.templateName,
        name: '模板',
        templateId: this.templateId,
      };
    });
    const navigation = this.utilService.getJSONParse(this.commonService.getLocalStorageByKey('navigation'), {});

    this.navigation = navigation.title ? navigation : this.globalCacheService?.navigation || {};
    if (this.templateName) {
      this.navigation = this.utilService.getJSONParse(this.template);
    }

    const params = {
      classifyId: this.pid,
      merchantId: this.globalCacheService.merchant.id,
      industryType: 0
    };
    this.getContentList(params);
  }

  ngOnDestroy(): void {
    this.paramsSubscription.unsubscribe();
  }

  backtrack(item: any): void {
    if (typeof item === 'object' && item?.jumpType) {
      this.commonService.setLocalStorageByKey('navigation', item);
    } else {
      this.commonService.setLocalStorageByKey('navigation', {});
    }
    this.globalCacheService.article = {};
    this.navigateService.multiTypeJump(item);
  }

  async getContentList(item): Promise<any> {
    try {
      const getContentList = await this.templateService.getClassifyList(item);
      const data = getContentList.data || [];
      for (const mpv in data.classifyList) {
        if (data.classifyList[mpv].id == this.pid) {
          this.elderId = data.classifyList[mpv].pid;
        }
      }
      for (const mpv in data.classifyList) {
        if (data.classifyList[mpv].id == this.elderId) {
          this.lucaId01 = data.classifyList[mpv].pid;
          this.elderTitle = data.classifyList[mpv].name;
        }
      }
      if (this.elderTitle == this.navigation.title) {
        this.elderTitle = '';
      }

      for (const mpv in data.classifyList) {
        if (data.classifyList[mpv].id == this.lucaId01) {
          this.lucaId02 = data.classifyList[mpv].pid;
          this.lucaTitle01 = data.classifyList[mpv].name;
        }
      }
      if (this.lucaTitle01 == this.navigation.title) {
        this.lucaTitle01 = '';
      }

      for (const mpv in data.classifyList) {
        if (data.classifyList[mpv].id == this.lucaId02) {
          this.lucaId03 = data.classifyList[mpv].pid;
          this.lucaTitle02 = data.classifyList[mpv].name;
        }
      }
      if (this.lucaTitle02 == this.navigation.title) {
        this.lucaTitle02 = '';
      }

      for (const mpv in data.classifyList) {
        if (data.classifyList[mpv].id == this.lucaId03) {
          this.lucaTitle03 = data.classifyList[mpv].name;
        }
      }
      if (this.lucaTitle03 == this.navigation.title) {
        this.lucaTitle03 = '';
      }

    } catch (error) {
      console.log(error);
    }
  }
}
